import React, { ComponentProps } from "react";

export default function PlayIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <mask
        id="mask0_297_362645"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_297_362645)">
        <path
          d="M5.35077 19.3376V4.66241C5.35077 4.05636 5.55639 3.56394 5.96765 3.18515C6.3789 2.80637 6.85509 2.61697 7.39621 2.61697C7.56937 2.61697 7.75335 2.63862 7.94815 2.68191C8.14295 2.7252 8.32693 2.80096 8.50009 2.90918L20.0584 10.2792C20.3615 10.4741 20.5941 10.7284 20.7565 11.0422C20.9188 11.3561 21 11.6753 21 12C21 12.3247 20.9188 12.6439 20.7565 12.9578C20.5941 13.2716 20.3615 13.526 20.0584 13.7208L8.50009 21.0908C8.32693 21.1991 8.14295 21.2748 7.94815 21.3181C7.75335 21.3614 7.56937 21.383 7.39621 21.383C6.85509 21.383 6.3789 21.1937 5.96765 20.8149C5.55639 20.4361 5.35077 19.9437 5.35077 19.3376Z"
          fill={props.fill || "white"}
        />
      </g>
    </svg>
  );
}
